import { Stack, Typography } from '@mui/material'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import DoneIcon from '@mui/icons-material/Done'
import { IThreadMessage } from 'types/threads'
import { formatTimeStampToDate } from 'hooks/date/formattedTime'
import { DownloadFile } from 'components/DownloadFile'

type Props = {
  align?: 'left' | 'right'
  message: IThreadMessage
}

export const ChatMessage = ({ align = 'right', message }: Props) => {
  const isSender = align === 'right' ? true : false
  const alignSelf = align === 'right' ? 'end' : 'start'
  const backgroundColor = isSender ? '#87ceeb' : '#ccc'

  return (
    <Stack
      maxWidth="75%"
      alignSelf={alignSelf}
      alignItems="flex-end"
      sx={{ borderRadius: '8px', padding: '8px', backgroundColor }}
    >
      <Typography width="100%">{message.messageBody}</Typography>
      {message.uploadedFileId && (
        <Typography variant="body1">
          <DownloadFile fileId={message.uploadedFileId} />
        </Typography>
      )}
      <Stack alignItems="center" direction="row" spacing={0.25}>
        <Typography fontSize="11px">
          {formatTimeStampToDate(message.createdAt)}
        </Typography>

        {message.viewed ? (
          <DoneAllIcon sx={{ fontSize: 16, color: 'green' }} />
        ) : (
          <DoneIcon sx={{ fontSize: 16, color: 'green' }} />
        )}
      </Stack>
    </Stack>
  )
}
